import { useAuthService } from '~/composables/useAuthService';
export default defineNuxtPlugin(async (nuxtApp) => {
    const { init } = useAuthService();

    // Initialize auth state before middleware runs
    // This reads cookies and sets up state for middleware to use
    await init();
});
